export default __webpack_public_path__ + "6dbb5fd3e1b0dac4e3b4c9d4a728c71d.svg";